export default {
	ONBOARDING_ACTIVITY_STATUS_NOTIFICATION: 'ONBOARDING_ACTIVITY_STATUS_NOTIFICATION_ID',
	FEATURE_USER_SCHOOL_PROFILE_OVERLAY_ID: 'FEATURE_USER_SCHOOL_PROFILE_OVERLAY_ID',
}
